import { combineReducers } from 'redux';
import configureStore from './createStore';
import rootSaga from '../sagas';

export default () => {
    /* eslint-disable global-require */

    const rootReducer = combineReducers({
        caravans: require('./caravansRedux').reducer,
        parts: require('./partsRedux').reducer,
        navigation: require('./navigationRedux').reducer,
        configuration: require('./configurationRedux').reducer,
        showForm: require('./showFormRedux').reducer,
        shownSteps: require('./shownStepsRedux').reducer,
        locale: require('./localeRedux').reducer,
    });

    /* eslint-enable global-require */

    return configureStore(rootReducer, rootSaga);
};
